/**
 * MagicBI Design System - Themes Index
 * 
 * Central export for all theme configurations and utilities.
 */

import { lightTheme } from "./light";
import { darkTheme } from "./dark";

export { lightTheme } from './light';
export { darkTheme } from './dark';

// Theme utilities
export const themes = {
  light: lightTheme,
  dark: darkTheme,
} as const;

export const getTheme = (mode: 'light' | 'dark') => themes[mode];

// Default theme
export const defaultTheme = lightTheme;

// Re-export theme types
export type {
  Theme,
  BaseTheme,
  ThemeMode,
  ThemeConfig,
  ThemeContextType,
  ThemeProviderProps,
} from '../types/theme';
